import { encode as base64_encode } from "base-64";
import config from "../config";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class PassengerStore {
  passengers = [];
  rootTripListArray = [];
  assetVehicleList = [];
  getClass = [];

  total = 0;
  loading = false;
  rootStore;
  photoFromDb = {};
  fileUploadUrl = "/passenger/fileUpload";

  constructor(rootStore) {
    makeObservable(this, {
      passengers: observable,
      rootTripListArray: observable,
      assetVehicleList: observable,
      getClass: observable,
      total: observable,
      loading: observable,
      photoFromDb: observable,
      loadData: action,
      deleteRecord: action,
      getRouteTripList: action,
      addData: action,
      sampleExcelFormat: action,
      addStudentByExcel: action,
      reAssignVehicle: action,
      getAllClass: action,
      getBusNo: action,
      setPhotoFromDb: action,
      fileUploadUrl: observable,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, searchField, companyId }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      offset: offset,
      limit: limit,
      searchField: searchField,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=passenger&a=passdetails", "postData=" + base64Input);
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("/passenger/get-passenger-details", {
        params: postData,
      });
    this.passengers = response?.data?.data?.passengers;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }
  async setPhotoFromDb(photo) {
    console.log(photo);
    this.photoFromDb = { fileList: photo };
  }
  async getPassenger(passengerId, limit, offset) {
    const postData = { passengerId: passengerId, limit: 1, offset: 0 };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=passenger&a=passdetails", "postData=" + base64Input);

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("/passenger/get-passenger-details", {
        params: postData,
      });
    const singleRow = response?.data?.data?.passengers[0];

    if (singleRow.photo) {
      const fileList = [
        {
          name: singleRow.photo,
          status: "success",
          url: config.fleetURL + "/images/students/" + singleRow.photo,
        },
      ];

      await this.setPhotoFromDb(fileList);
    }
    return singleRow;
  }

  async deleteRecord({ passengerId }) {
    // var postData = { passengerId: passengerId };
    var queryParams = { passengerId: passengerId };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete("/passenger/delete", {
        params: queryParams,
      });
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=passenger&a=delete", "postData=" + base64Input);
    return response;
  }

  async addData(studentData) {
    // var postData = {
    //   tokenId: "",
    //   AddPassenger: studentData,
    // };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("/passenger/createOrUpdate", studentData);
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=passenger&a=update", "postData=" + base64Input);

    return response.data;
  }

  async getRouteTripList({
    companyId,
    pickuplatitude,
    pickuplongitude,
    classId,
    offset,
    limit,
    userId,
    isadmin,
  }) {
    var postData = {
      companyId: companyId,
      pickuplatitude: pickuplatitude,
      pickuplongitude: pickuplongitude,
      classId: classId,
      userId: userId,
      isadmin: isadmin,
      offset: offset,
      limit: limit,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=passenger&a=getRouteTripList",
        "postData=" + base64Input
      );
    this.rootTripListArray = response;
  }

  async sampleExcelFormat() {
    window.location.href = window.location.href =
      config.fleetURL + "/appRes/excel/Student.xlsx";
    // "https://awtltrack.com/public/fleet/appRes/excel/Student.xlsx";
  }

  async addStudentByExcel(excelFile) {
    this.excelLoadig = true;
    var postData = excelFile;

    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("/passenger/passengerImport", postData);
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=passenger&a=studentexcel2", "postData=" + base64Input);
    this.excelLoadig = false;
    return response.data;
  }

  async reAssignVehicle(renewData) {
    var postData = renewData;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=passenger&a=reassignvehicle",
    //     "postData=" + base64Input
    //   );

    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("/passenger/reAssignVehicle", renewData);

    return response.data;
  }

  async getAllClass() {
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=notification&a=getAllClass",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("notifications/getAllClass");

    this.getClass = response?.data?.data;
    return response?.data?.data;
  }

  async getBusNo(companyId) {
    var postData = {
      companyId: companyId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/getVehicles", { params: postData });

    // let allVehicles = [{ "vehicleId": 0, "vehicleNo": "ALL" }];

    this.assetVehicleList = response?.data?.vehicleData;
    return response?.data?.vehicleData;
  }
}

export default PassengerStore;
